import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { ReusableStreamMethod } from '@ipreo/muni-shared';
import { GameDayRootReducerState } from '../../state/root.state';
import { mapAccountAmountData } from '../mappers/accounts.calculations';
import { AccountReport } from '../models/account';
import { getTrancheOrdersFilteredState } from '../../state/data/reducer';

@Injectable()
export class AccountsReportsService {
  constructor(private store: Store<GameDayRootReducerState>) {}

  @ReusableStreamMethod
  public getAccountAmountsData(): Observable<AccountReport[]> {
    return this.store.pipe(
      select(getTrancheOrdersFilteredState),
      map(({ orders }) => orders),
      filter(orders => !!orders),
      distinctUntilChanged(),
      map(mapAccountAmountData)
    );
  }

  @ReusableStreamMethod
  public getAccountsTotalsByTypes(): Observable<AccountReport> {
    return this.getAccountAmountsData().pipe(
      map(accountsArray =>
        accountsArray.reduce(
          (acc: AccountReport, next: AccountReport) => ({
            ...acc,
            retailAmount: +next.retailAmount + acc.retailAmount,
            institutionalAmount:
              +next.institutionalAmount + acc.institutionalAmount,
            total: +next.total + acc.total
          }),
          {
            retailAmount: 0,
            institutionalAmount: 0,
            total: 0,
            name: `${accountsArray.length} Accounts`
          } as AccountReport
        )
      )
    );
  }
}
